import { render, staticRenderFns } from "./LclTextStand.vue?vue&type=template&id=ffbc374a&scoped=true"
import script from "./LclTextStand.vue?vue&type=script&lang=js"
export * from "./LclTextStand.vue?vue&type=script&lang=js"
import style0 from "./LclTextStand.vue?vue&type=style&index=0&id=ffbc374a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbc374a",
  null
  
)

export default component.exports